import { createContext, useContext } from 'react';
import { useTeleportToTarget, type TeleportContextValue } from '@/hooks/useTeleportToTarget';

const TeleportContext = createContext<TeleportContextValue | null>(null);

export function useTeleport(): TeleportContextValue {
  const ctx = useContext(TeleportContext);
  if (!ctx) {
    throw new Error('useTeleport must be used within TeleportProvider');
  }
  return ctx;
}

export function useTeleportOptional(): TeleportContextValue | null {
  return useContext(TeleportContext);
}

export { TeleportContext };

export interface TeleportProviderProps {
  onScheduleMonthChange?: (year: number, month: number) => void;
  children: React.ReactNode;
}

export function TeleportProvider({ onScheduleMonthChange, children }: TeleportProviderProps) {
  const value = useTeleportToTarget(onScheduleMonthChange);
  return (
    <TeleportContext.Provider value={value}>
      {children}
    </TeleportContext.Provider>
  );
}
